module.exports = __webpack_public_path__ + "static/media/Services.207218f5.png";